import { Modal } from "@components/Modal";
import { useTranslation } from "@helpers/useTranslation";
import { FC } from "react";

type Props = {
  show: boolean;
  onClose: () => void;
  isCamdeed?: boolean;
};

export const HowToDownloadModal: FC<Props> = ({ show, onClose, isCamdeed = false }) => {
  const { t } = useTranslation("admin");

  if (!show) return null;

  // Choose the correct infographic based on branding
  const infographicSrc = isCamdeed ? "/how-to-download.jpg" : "/how-to-download.jpg";

  return (
    <Modal show={show} onCancel={onClose} className="z-50" size="lg" hideX>
      <div className="flex flex-col items-center space-y-4">
        <h3 className="text-center text-lg font-bold">{t("howToDownload")}</h3>

        <div className="flex w-full justify-center">
          <img
            src={infographicSrc}
            alt={t("downloadInstruction")}
            className="h-auto max-w-full rounded-lg shadow-lg"
            style={{ maxHeight: "60vh" }}
          />
        </div>

        <div className="flex justify-center pt-4">
          <button onClick={onClose} className="btn-primary btn px-8">
            {t("iUnderstand")}
          </button>
        </div>
      </div>
    </Modal>
  );
};
